const ACTIONS = {
  GET_CONTAINER: 'GET_CONTAINER',
  GET_CONTAINER_SUCCESS: 'GET_CONTAINER_SUCCESS',
  GET_CONTAINER_FAILED: 'GET_CONTAINER_FAILED',

  GET_COLLECTIONS: 'GET_COLLECTIONS',
  GET_COLLECTIONS_SUCCESS: 'GET_COLLECTIONS_SUCCESS',
  GET_COLLECTIONS_FAILED: 'GET_COLLECTIONS_FAILED',

  SELECT_COLLECTION: 'SELECT_COLLECTION',
};

const reducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case ACTIONS.GET_CONTAINER:
      return {
        ...state,
        isLoadingContainer: true,
        loadContainerError: null,
      };
    case ACTIONS.GET_CONTAINER_SUCCESS:
      return {
        ...state,
        isLoadingContainer: false,
        isEnabled: payload.collectionsEnabled,
      };
    case ACTIONS.GET_CONTAINER_FAILED:
      return {
        ...state,
        isLoadingContainer: false,
        loadContainerError: payload, // store error may handle in future
      };
    case ACTIONS.GET_COLLECTIONS:
      return {
        ...state,
        isLoadingCollections: true,
        loadContainerError: null,
      };
    case ACTIONS.GET_COLLECTIONS_SUCCESS:
      return {
        ...state,
        isLoadingCollections: false,
        collections: payload.results || [],
      };
    case ACTIONS.GET_COLLECTIONS_FAILED:
      return {
        ...state,
        isLoadingCollections: false,
        loadContainerError: payload, // store error may handle in future
      };
    case ACTIONS.SELECT_COLLECTION:
      return {
        ...state,
        selectedId: payload.id,
      };
    default:
      return state;
  }
};

export { ACTIONS, reducer };
